import React from "react";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

import { KeyboardArrowUp, KeyboardArrowDown } from "components/Icons";

import "./style.scss";

interface IProps {
  children: JSX.Element[] | JSX.Element;
  renderExpanded?: any;
  pageName?: string;
}

interface IState {
  expanded: boolean;
}

class DetailView extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false
    };
  }

  public componentDidMount() {
    const { pageName } = this.props;

    if (pageName) {
      const savedSettings = JSON.parse(
        localStorage.getItem("customSettings") || "{}"
      );
      const expanded = _.get(savedSettings, `${pageName}.expanded`, false);

      this.setState({ expanded });
    }
  }

  private handleExpander = () => {
    const { expanded } = this.state;
    const { pageName } = this.props;

    this.setState({ expanded: !expanded });

    if (pageName) {
      const savedSettings = JSON.parse(
        localStorage.getItem("customSettings") || "{}"
      );
      _.set(savedSettings, `${pageName}.expanded`, !expanded);
      localStorage.setItem("customSettings", JSON.stringify(savedSettings));
    }
  };

  public render() {
    const { children, renderExpanded } = this.props;
    const { expanded } = this.state;

    return (
      <div className="detail-view">
        {children}
        {expanded && renderExpanded()}
        {renderExpanded && (
          <div className="expander">
            <div onClick={this.handleExpander}>
              {expanded ? (
                <span>
                  <FormattedMessage id="SHOW_LESS" />
                  <KeyboardArrowUp />
                </span>
              ) : (
                <span>
                  <FormattedMessage id="SHOW_MORE" />
                  <KeyboardArrowDown />
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default DetailView;
